import { React, useContext } from "react";
import { IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { AiFillAlert } from "react-icons/ai";
import { createWorkOrder } from "../../../services/MaintenanceServices";
import {
  notifyError,
  notifySuccess,
} from "../../../components/Toaster/Toaster";
import { AppContext } from "../../../context/AppContextProvider";
import { assignWorkOrderStatus } from "../../../services/DeviceService";

export const ButtonCellRenderAlert = ({
  data,
  // onActionComplete,
  confirmationModal,
}) => {
  const {
    id,
    device,
    name,
    message,
    severity,
    workOrderStatus,
    triggeredTime,
    status,
  } = data.data;

  const incidentStatus = (severity) => {
    switch (severity) {
      case "Critical":
        return 1;
      case "Warning":
        return 2;
      case "Info":
        return 3;
      default:
        throw new Error("Invalid incident status");
    }
  };
  const payload = {
    workorderId: "",
    device_serial_number: device,
    work_type: "A",
    error_Code: name,
    assigned_Technician: "",
    scheduled_date: "0001-01-01 00:00:00",
    priority: incidentStatus(severity),
    issue_Description: message,
    status: "Open",
    issue_triggered_at: triggeredTime,
    technician_Comments: "",
    manager_Comments: "",
    issue_resolved_at: "",
    attachments: [],
  };

  // const createAutoIncident = async (payload) => {
  //   try {
  //     const response = await createWorkOrder(payload);
  //     if (response && response.data) {
  //       notifySuccess("Work order Added successfully");
  //     }
  //   } catch (error) {
  //     console.error("Error creating work order:", error);
  //     notifyError("Failed to Raise Work Order");
  //   }
  // };

  const isDisabled = () => {
    return workOrderStatus === "Raised" || status === "Resolved";
  };

  const getIconColor = () => {
    if (workOrderStatus === "Raised") {
      return "#1fc0ff"; // Blue color for Raised status
    } else if (status === "Resolved") {
      return "#39FF14"; // Green color for Resolved status
    }
    return "#ff073a"; // Red color for Unresolved & Unraised Status
  };
  // Dheeraj Edit

  // const updateWorkOrderStatusAlert = async (alertId) => {
  //   await assignWorkOrderStatus(alertId);
  // };

  // const clickHandler = async () => {
  //   try {
  //     await createAutoIncident(payload);
  //     await updateWorkOrderStatusAlert(id);
  //     onActionComplete();
  //   } catch (error) {
  //     console.error("Error in clickHandler: ", error);
  //   }
  // };

  const clickHandler = () => confirmationModal(data.data);

  return (
    <Tooltip title={isDisabled() ? "" : "Raise Incident"}>
      <span>
        <IconButton onClick={clickHandler} disabled={isDisabled()}>
          <AiFillAlert style={{ color: getIconColor() }} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
